export default class CityActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_CITY='GET_HELPER_CITY';
  static SUCCESS_DATA='SUCCESS_DATA';

  static submit(){
    return {
      type: CityActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: CityActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: CityActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: CityActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: CityActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: CityActions.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: CityActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: CityActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: CityActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: CityActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: CityActions.GET_HELPER_CITY,
      payload:data
    };
  }
}